import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/posts/new")({
  component: lazyRouteComponent(() => import("@/pages/admin/PostEditor")),
});
